export enum CommentType {
  Observation = 1,
  Comment = 2,
  Cancellation = 3,
  Modification = 4
}
